export default __webpack_public_path__ + "images/indeed-flex-logo-v2-360c05.svg";